export default __webpack_public_path__ + "static/team_retreat_2-150f6fd035c681f3966e2cf5cea63585.jpg";